import { NavigationProp, RouteProp, useNavigation, useRoute } from '@react-navigation/native'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'

import { ButtonForm } from '../components'
import { formStyles } from '../components/CategoryFailureForms/styles'
import { TextInput } from 'react-native-gesture-handler'
import { TemplatePage } from '../../../components/TemplatePage'
import { useForm } from '../../../hooks/useForm'
import { buttonStyle } from '../../../theme/buttons'
import { corporateColor, disabledGray } from '../../../theme/colors'
import { globalStyle } from '../../../theme/global'
import { inputStyle } from '../../../theme/inputs'
import { Detail } from '../../../types'
import { useTranslation } from 'react-i18next'
import { ControlServicesRoutes } from '../../../navigator/types'

interface Navigation extends NavigationProp<ControlServicesRoutes, 'CategoryFour'> {}
export const CategoryThree = () => {
  const { t } = useTranslation()
  const { navigate } = useNavigation<Navigation>()
  const route = useRoute<RouteProp<ControlServicesRoutes, 'CategoryFour'>>()

  const detail = route.params.detail[0]

  const { values, onChangeValues: handleSetValues } = useForm({
    notRov: !detail?.rov,
    hasRov: detail?.rov ?? false,
    operator: detail?.operator ?? '',
  })

  const handleDisabled = () => !Object.values(values).some((val) => val)

  const handleNavigate = () => {
    const detail: Detail[] = [
      {
        idCage: null,
        m2: null,
        nameCage: null,
        operator: values.operator,
        rov: values.hasRov,
      },
    ]
    navigate('FinalForm', { ...route.params, detail })
  }

  return (
    <TemplatePage
      styleContent={{ padding: 0, marginBottom: 0 }}
      header
      title={route.params.namePage.toUpperCase()}
    >
      <View style={[globalStyle.viewContainer, { justifyContent: 'center' }]}>
        <Text style={styles.info}>{t('Valida la siguiente información')}</Text>
        <ButtonForm
          isActive={values.notRov}
          label={t('No uso de ROV')}
          onPress={() => {
            handleSetValues({ name: 'notRov', value: !values.notRov })
            handleSetValues({ name: 'hasRov', value: false })
            handleSetValues({ name: 'operator', value: '' })
          }}
        />
        <ButtonForm
          isActive={values.hasRov}
          label={t('Uso de ROV')}
          onPress={() => {
            handleSetValues({ name: 'hasRov', value: !values.hasRov })
            handleSetValues({ name: 'notRov', value: false })
          }}
        />

        {values.hasRov && (
          <View style={styles.inputContainer}>
            <Text style={formStyles.label}>{t('NOMBRE')}</Text>
            <TextInput
              onChangeText={(value) => handleSetValues({ value, name: 'operator' })}
              value={values.operator}
              style={[inputStyle.basicInput]}
            />
          </View>
        )}
        <TouchableOpacity
          style={[
            buttonStyle.basic,
            handleDisabled() && { backgroundColor: disabledGray },
            { width: '90%', marginBottom: 10, marginTop: 20 },
          ]}
          onPress={handleNavigate}
          activeOpacity={0.7}
          disabled={handleDisabled()}
        >
          <Text style={buttonStyle.text}>{t('Continuar')}</Text>
        </TouchableOpacity>
      </View>
    </TemplatePage>
  )
}

const styles = StyleSheet.create({
  inputContainer: {
    marginVertical: 10,
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 20,
  },

  info: {
    color: corporateColor,
    fontWeight: 'bold',
    fontSize: 17,
    textAlign: 'center',
    marginBottom: 15,
  },
})
